/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_age_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is my date of birth stored?`)
};

const es_age_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Se almacena mi fecha de nacimiento?`)
};

const de_age_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird mein Geburtsdatum gespeichert?`)
};

const nl_age_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wordt mijn geboortedatum opgeslagen?`)
};

const fr_age_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ma date de naissance est-elle stockée ?`)
};

const it_age_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La mia data di nascita è memorizzata?`)
};

const pt_br2_age_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minha data de nascimento é armazenada?`)
};

const pt_age_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A minha data de nascimento é armazenada?`)
};

const ja_age_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生年月日は保存されますか？`)
};

const zh_age_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我的出生日期会被存储吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const age_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.age_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("age_faq3_q", locale)
	if (locale === "en") return en_age_faq3_q(inputs)
	if (locale === "es") return es_age_faq3_q(inputs)
	if (locale === "de") return de_age_faq3_q(inputs)
	if (locale === "nl") return nl_age_faq3_q(inputs)
	if (locale === "fr") return fr_age_faq3_q(inputs)
	if (locale === "it") return it_age_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_age_faq3_q(inputs)
	if (locale === "pt") return pt_age_faq3_q(inputs)
	if (locale === "ja") return ja_age_faq3_q(inputs)
	return zh_age_faq3_q(inputs)
};